import { registerLocaleData } from '@angular/common';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import localeId from '@angular/common/locales/id';
import { LOCALE_ID, NgModule } from '@angular/core';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import {
	DateAdapter,
	MAT_DATE_FORMATS,
	MAT_DATE_LOCALE,
} from '@angular/material/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { DATE_PICKER_FORMATS } from './app-config.const';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthGuard } from './core/auth/guard';
import { AuthInterceptor, ErrorInterceptor } from './core/interceptor';
import { ToastrModule } from "ngx-toastr";
import { StoreModule } from '@ngrx/store';
import { MRSowReducer } from '../app/store/reducers/mr-pw-planning-and-function/sow.reducer';

registerLocaleData(localeId);

@NgModule({
	declarations: [AppComponent],
	imports: [
		BrowserModule,
		BrowserAnimationsModule,
		AppRoutingModule,
		HttpClientModule,
		ToastrModule.forRoot(),
		StoreModule.forRoot(
			{
				mr_pw_planning_and_function: MRSowReducer
			}
		),
	],
	bootstrap: [AppComponent],
	providers: [
		{
			provide: DateAdapter,
			useClass: MomentDateAdapter,
			deps: [MAT_DATE_LOCALE],
		},
		{
			provide: MAT_DATE_FORMATS,
			useValue: DATE_PICKER_FORMATS,
		},
		{
			provide: LOCALE_ID,
			useValue: 'id',
		},
		AuthGuard,
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		},
		{
			provide: HTTP_INTERCEPTORS,
			useClass: ErrorInterceptor,
			multi: true,
		},
	],
})
export class AppModule {}
